export default __webpack_public_path__ + "static/media/harbor.0f2c9613.png";